import { IIcon } from '../../model/icon';

export const arrow: IIcon = {
  id: ``,
  svg: `
  <path d="M15.41 16.5795L10.83 11.9995L15.41 7.40951L14 5.99951L8 11.9995L14 17.9995L15.41 16.5795Z"
      fill="#00AB8D" />
  `
};
